import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/operate",
  },
  // {
  //   path: "/404",
  //   name: "Page404",
  //   meta: { title: "404" },
  //   component: () => import("../views/404.vue"),
  // },
  {
    path: "/boss",
    name: "Boss",
    meta: { title: "BOSS财报" },
    component: () => import("../views/boss/index.vue"),
  },
  {
    path: "/table",
    name: "Table",
    component: () => import("../views/table/index.vue"),
  },
  {
    path: "/operate",
    name: "Operate",
    meta: { title: "运营中心" },
    component: () => import("../views/operate/index.vue"),
  },
  {
    path: "/region/:name",
    name: "Region",
    meta: { title: "区域视角" },
    component: () => import("../views/operate/index.vue"),
  },
  {
    path: "/shop/:name",
    name: "Shop",
    meta: { title: "门店视角" },
    component: () => import("../views/shop/index.vue"),
  },
  {
    path: "/permission",
    name: "Per",
    meta: { title: "暂无权限" },
    component: () => import("../views/per.vue"),
  },
  {
    path: "/error",
    name: "Error",
    meta: { title: "钻立方" },
    component: () => import("../views/error.vue"),
  },
  // { path: "*", redirect: "/404" },
];

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0, top: 0 };
  },
});

export default router;
